import { render, staticRenderFns } from "./InventoryGridItem.vue?vue&type=template&id=8565bf48&scoped=true&"
import script from "./InventoryGridItem.vue?vue&type=script&lang=js&"
export * from "./InventoryGridItem.vue?vue&type=script&lang=js&"
import style0 from "./InventoryGridItem.vue?vue&type=style&index=0&id=8565bf48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8565bf48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAvatar,VBtn,VSelect})
